import qs from 'query-string';

const getUrlWithQs = (qsValue) => {
  const {
    protocol,
    host,
    pathname,
  } = window.location;

  return `${protocol}//${host}${pathname}?${qsValue}`;
};

export const getUrlWithNewQsValue = (key, value) => {
  const queryString = window.location.search;
  const values = qs.parse(queryString);

  const newQsValue = qs.stringify({ ...values, [key]: value });

  return getUrlWithQs(newQsValue);
};

const setQueryStringWithoutPageReload = (qsValue) => {
  const newUrl = getUrlWithQs(qsValue);

  window.history.pushState({ path: newUrl }, '', newUrl);
};

export const setQueryStringValue = (
  key,
  value,
  queryString = window.location.search,
) => {
  const values = qs.parse(queryString);
  const newQsValue = qs.stringify({ ...values, [key]: value });

  setQueryStringWithoutPageReload(newQsValue);
};

export const deleteQueryString = (
  key,
  queryString = window.location.search,
) => {
  const values = qs.parse(queryString);
  const { [key]: sliced, ...newValues } = values;
  const newQsValue = qs.stringify(newValues);
  setQueryStringWithoutPageReload(newQsValue);
};

export const getQueryStringValue = (
  key,
  queryString = window.location.search,
) => {
  const values = qs.parse(queryString);
  return values[key];
};

export const getIntValueFromQueryString = (key, defaultValue) => {
  const value = getQueryStringValue(key);

  if (!value) {
    return defaultValue;
  }

  return parseInt(value);
};

export const getIntValuesFromQueryString = (key, defaultValue) => {
  const value = getQueryStringValue(key);

  if (!value) {
    return defaultValue;
  }

  return Array.isArray(value) ? value.map(parseInt) : [parseInt(value)];
};
